// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/user_persona.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/user_persona.proto.
 */
export const file_studyo_today_planners_v1_resources_user_persona = /*@__PURE__*/
  fileDesc("CjVzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3VzZXJfcGVyc29uYS5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyqQAQoLVXNlclBlcnNvbmESHAoYVVNFUl9QRVJTT05BX1VOU1BFQ0lGSUVEEAASFwoTVVNFUl9QRVJTT05BX1BBUkVOVBABEhgKFFVTRVJfUEVSU09OQV9URUFDSEVSEAISGAoUVVNFUl9QRVJTT05BX1NUVURFTlQQAxIWChJVU0VSX1BFUlNPTkFfT1RIRVIQBEIqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the enum studyo.today.planners.v1.resources.UserPersona.
 */
export const UserPersonaSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_planners_v1_resources_user_persona, 0);

/**
 * A suggested persona for a user based on their answers during the onboarding flow.
 *
 * @generated from enum studyo.today.planners.v1.resources.UserPersona
 */
export const UserPersona = /*@__PURE__*/
  tsEnum(UserPersonaSchema);

